

import {
  Box,
  Typography,
  Grid,
} from "@mui/material";

import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";


export const TabsContacto = ({ 
                opcion,
                setOpcion,
                trabajoRef,
                matriculaRef,
                admisionRef
             }) => {


              const handleChangeTab = (id) => {
    setOpcion(id);

    const refs = {
        trabajo: trabajoRef,
        matricula: matriculaRef,
        consulta: admisionRef,
    };

    refs[id]?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
    });
};
  const opciones = [
    {
      id: "trabajo",
      titulo: "QUIERO TRABAJAR\nCON NOSOTROS",
      descripcion: "Envía tu CV y forma parte de nuestro equipo.",
      color: "#9c1f2d",
      icon: <WorkOutlineOutlinedIcon />,
    },
    {
      id: "matricula",
      titulo: "MATRÍCULAS",
      descripcion: "Información del proceso de matrículas 2026.",
      color: "#2f3f83",
      icon: <SchoolOutlinedIcon />,
    },
    {
      id: "consulta",
      titulo: "ADMISIÓN",
      descripcion: "Requisitos y proceso de admisión.",
      color: "#d8848d",
      icon: <ContactSupportOutlinedIcon />,
    },
  ];

 

  return (
    <Box>
    <Grid
  container
  spacing={{
    xs: 5,
    sm: 4,
    md: 4,
    lg: 5,
  }}
>
      {opciones.map((item) => {
       

        return (
          <Grid
          size={{xs:12,sm:6,md:4}}
            onClick={() => handleChangeTab(item.id)}
            key={item.id}
          >
            <Box
              onClick={() => handleChangeTab(item.id)}
              sx={{
  position: "relative",
  cursor: "pointer",
  pt: {
    xs: 5,
    sm: 6,
  },
  height: "100%",
}}
            >
              {/* Icono */}

              <Box
               sx={{
  position: "absolute",
  top: 0,
  left: "50%",
  transform: "translateX(-50%)",

  width: {
    xs: 72,
    sm: 82,
    md: 90,
    lg: 96,
  },

  height: {
    xs: 72,
    sm: 82,
    md: 90,
    lg: 96,
  },

  borderRadius: "50%",

  bgcolor: item.color,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  border: {
    xs: "4px solid #fff",
    md: "6px solid #fff",
  },

  boxShadow: "0 12px 30px rgba(0,0,0,.15)",

  zIndex: 3,

  transition: ".35s",

  "& svg": {
    fontSize: {
      xs: 34,
      sm: 38,
      md: 42,
      lg: 46,
    },
  },
}}
              >
                <Box
                  sx={{
                    color: "#fff",
                    "& svg": {
                      fontSize: 42,
                    },
                  }}
                >
                  {item.icon}
                </Box>
              </Box>

              {/* Card */}

              <Box
               sx={{
  bgcolor: "#fff",

  borderRadius: {
    xs: "18px",
    sm: "20px",
    md: "22px",
    lg: "24px",
  },

  p: {
    xs: 2.5,
    sm: 3,
    md: 4,
  },

  pt: {
    xs: 6,
    sm: 6.5,
    md: 7,
  },

  minHeight: {
    xs: 180,
    sm: 210,
    md: 220,
    lg: 235,
  },

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  textAlign: "center",

  borderBottom: `4px solid ${item.color}`,

  boxShadow: {
    xs: "0 10px 25px rgba(0,0,0,.08)",
    md: "0 12px 35px rgba(0,0,0,.08)",
  },

  transition: ".35s",

  "&:hover": {
    transform: {
      xs: "none",
      md: "translateY(-10px)",
    },

    boxShadow: "0 20px 45px rgba(0,0,0,.15)",
  },
}}
              >
                <Typography
                 sx={{
  fontWeight: 600,

  color: item.color,

  whiteSpace: "pre-line",

  textTransform: "uppercase",

  lineHeight: 1.2,

  mb: 1.5,

  fontSize: {
    xs: 15,
    sm: 17,
    md: 18,
    lg: 20,
  },
}}
                >
                  {item.titulo}
                </Typography>

                <Typography
                 sx={{
  color: "#666",

  lineHeight: 1.6,

  maxWidth: 250,

  fontSize: {
    xs: 13,
    sm: 14,
    md: 15,
    lg: 16,
  },
}}
                >
                  {item.descripcion}
                </Typography>
              </Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
    <Box
    sx={{
        mt:10
    }}>
       
    </Box>
    </Box>
  );
};